<template>
  <!-- ADD THE CLASS layout-top-nav TO REMOVE THE SIDEBAR. -->
  <div :class="['hold-transition','layout-top-nav', jeAdmin ? 'skin-blue' : 'skin-green']">
    <div class="wrapper">
      <header class="main-header">
        <nav class="navbar navbar-inverse">
          <div class="container-fluid">
            <div class="navbar-header">
              <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-collapse">
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <a class="navbar-brand" href="#" @click.prevent="homeButton()">
                e<b>Q</b>uiz
              </a>
            </div>
            <div>
              <div class="collapse navbar-collapse" id="navbar-collapse">
                <!--student navbar-->
                <ul v-if="!isSimpleHeader && !jeAdmin" class="nav navbar-nav">
                  <li v-if="!selectedGroupId"><a href="#" @click.prevent="s()">{{ $t('header.groups') }}</a></li>
                  <li class="dropdown active" v-if="selectedGroupId && selectedGroup">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown" v-if="selectedGroup.group">
                      {{selectedGroup.group.name | pickTranslation}}
                      <span class="fa fa-caret-down"></span>
                    </a>
                    <ul class="dropdown-menu" role="menu">
                      <li>
                        <a @click="goToExercises()" href="#">{{ $t('header.exercises') }}</a>
                      </li>
                      <li>
                        <a href="#" @click="goToProgress()">{{ $t('header.progress') }}</a>
                      </li>
                      <li class="divider"></li>
                      <li>
                        <a @click="leaveGroup()" href="#">{{ $t('header.leave') }}</a>
                      </li>
                    </ul>
                  </li>
                  <!--<li class="dropdown active" v-if="selectedGroupId && selectedGroup.years.length > 1">-->
                    <!--<a href="#" class="dropdown-toggle" data-toggle="dropdown">{{selectedYear.name}}-->
                      <!--<span class="caret"></span>-->
                    <!--</a>-->
                    <!--<ul class="dropdown-menu" role="menu">-->
                      <!--<li v-for="year in selectedGroup.years">-->
                        <!--<a @click="changeYear(year)" href="#">{{year.name}}</a>-->
                      <!--</li>-->
                    <!--</ul>-->
                  <!--</li>-->
                </ul>
                <!--Admin navbar-->
                <ul v-if="!isSimpleHeader && jeAdmin" class="nav navbar-nav">
                  <!-- <li class="dropdown">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">{{ $t('pages.group.bannerName') }}
                    <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu" role="menu">
                      <li v-for="group in groupList">
                        <a @click="navigateToGroupAdmin(group)" href="#">{{group.name | pickTranslation}}</a>
                      </li>
                    </ul>
                  </li> -->
                  <li v-if="!selectedGroupId"><a href="#" @click.prevent="s()">{{ $t('pages.group.bannerName') }}</a></li>
                  <li class="dropdown active" v-if="selectedGroupId && selectedGroup.group">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                      {{selectedGroup.group.name | pickTranslation}}
                      <span class="fa fa-caret-down"></span>
                    </a>
                    <ul class="dropdown-menu" role="menu">
                      <li>
                        <a @click="goToExercises()" href="#">{{ $t('header.exercises') }}</a>
                      </li>
                      <li>
                        <a @click="goToClasses()" href="#">{{ $t('header.classes') }}</a>
                      </li>
                      <li>
                        <a href="#">{{ $t('header.statistics') }}
                          <span class="pull-right-container">
                            <small class="label pull-right bg-blue">?</small>
                          </span>
                        </a>
                        <a href="#"></a>
                      </li>
                      <li class="divider"></li>
                      <li>
                        <a @click="goToPanel()" href="#">{{ $t('header.panel') }}</a>
                      </li>
                      <li class="divider"></li>
                      <li>
                        <a @click="leaveGroup()" href="#">{{ $t('header.leave') }}</a>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown active" v-if="selectedGroupId">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">{{selectedYear.name}}
                      <span class="fa fa-caret-down"></span>
                    </a>
                    <ul class="dropdown-menu" role="menu">
                      <li v-for="year in selectedGroup.years" :key="year.id">
                        <a @click="changeYear(year)" href="#">{{year.name}}</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="#" @click.prevent="goToLibrary()">{{ $t('header.library') }}</a>
                  </li>
                  <li>
                    <a href="#" @click.prevent="goToUsers()">{{ $t('header.users') }}</a>
                  </li>
                  <li>
                    <a href="#" @click.prevent="goToTablets()">{{ $t('header.tablets') }}</a>
                  </li>
                </ul>
                <ul class="nav navbar-nav navbar-right">
                  <!-- Additional tools menu -->
                  <li v-if="!isSimpleHeader && jeAdmin &&!isCollapsed()" class="dropdown notifications-menu" @click="updateReports()">
                    <!-- Menu toggle button -->
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                      <span class="glyphicon glyphicon-flag"></span>
                    </a>
                    <ul class="dropdown-menu">
                      <li class="header">{{ $t('header.reportsStart') }} {{pendingReports.length}} {{ $t('header.reportsEnd') }}</li>
                      <li class="footer">
                        <router-link :to="{name: 'reports'}">
                          <i class="fa fa-users text-aqua"></i> {{ $t('header.reportsView') }}
                        </router-link>
                      </li>
                    </ul>
                  </li>
                  <li v-if="!isSimpleHeader && jeAdmin && isCollapsed()" class="dropdown notifications-menu" @click="updateReports()">
                    <!-- ce je meni zlozen -->
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                      {{ $t('header.reports') }}
                    </a>
                    <ul class="dropdown-menu" style="width: auto">
                      <li class="header">{{ $t('header.reportsStart') }} {{pendingReports.length}} {{ $t('header.reportsEnd') }}</li>
                      <li class="footer">
                        <router-link :to="{name: 'reports'}">
                          <i class="fa fa-users text-aqua"></i> {{ $t('header.reportsView') }}
                        </router-link>
                      </li>
                    </ul>
                  </li>
                  <!-- User Account Menu -->
                  <li v-if="!isSimpleHeader && !isCollapsed()" class="dropdown user user-menu">
                    <!-- Menu Toggle Button -->
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                      <!-- The user image in the navbar-->
                      <img :src="profilePicture" class="user-image" alt="User Image"  v-if="!isCollapsed()">
                      <!-- hidden-xs hides the username on small devices so only the image appears. -->
                      <span class="">{{ userLoggedIn }}</span>
                    </a>
                    <ul class="dropdown-menu">
                      <!-- The user image in the menu -->
                      <li class="user-header">
                        <img :src="profilePicture" class="img-circle" alt="User Image">
                        <p>
                          {{ userLoggedIn }}
                        </p>
                      </li>
                      <!-- Menu Body -->
                      <!-- Menu Footer-->
                      <li class="user-footer">
                        <div class="pull-left">
                          <a href="#" class="btn btn-default btn-flat" @click.prevent="goToProfile(userId)">{{ $t('pages.userIconInHeader.profile') }}</a>
                        </div>
                        <div class="pull-right">
                          <a v-if="!isSimpleHeader" class="btn btn-default btn-flat" @click.prevent="logout">{{ $t('pages.userIconInHeader.signOut') }}</a>
                          <a v-else class="btn btn-default btn-flat" @click.prevent="logout">{{$t('pages.userIconInHeader.pleaseLogin') }}</a>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li v-if="!isSimpleHeader && isCollapsed()">
                    <a href="#" @click="goToProfile(userId)">
                      <span style="font-weight: bold">{{ userLoggedIn }} ({{ $t('pages.userIconInHeader.profile') }})</span>
                    </a>
                  </li>
                  <li v-if="!isSimpleHeader && isCollapsed()">
                    <a href="#" @click="logout">
                      <span>{{ $t('pages.userIconInHeader.signOut') }}</span>
                    </a>
                  </li>
                  <!-- Languages Menu -->
                  <li class="dropdown tasks-menu">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                      <span class="glyphicon glyphicon-globe"></span>
                    </a>
                    <ul class="dropdown-menu" v-if="!isCollapsed()" style="width: 11em;">
                      <li>
                        <!-- inner menu: contains the actual data -->
                        <ul class="menu" >
                          <li>
                            <!-- Task item -->
                            <a href="#" @click.prevent="changeLocale('sl')">
                              <h3>
                                <i class="fa fa-flag"></i>
                                {{$t("header.langSlo")}}
                              </h3>
                            </a>
                          </li>
                          <!-- end task item -->
                          <li>
                            <!-- Task item -->
                            <a href="#" @click.prevent="changeLocale('en')">
                              <h3>
                                <i class="fa fa-flag"></i>
                                {{$t("header.langEng")}}
                              </h3>
                            </a>
                          </li>
                          <!-- end task item -->
                        </ul>
                      </li>
                    </ul>
                    <ul class="dropdown-menu" v-else>
                      <li>
                        <a @click.prevent="changeLocale('sl')">
                            <i class="fa fa-flag"></i>
                            {{$t("header.langSlo")}}
                        </a>
                      </li>
                      <li>
                        <a @click.prevent="changeLocale('en')">
                            <i class="fa fa-flag"></i>
                            {{$t("header.langEng")}}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <!-- Full Width Column -->
      <div class="content-wrapper" :class="{'auth-wrapper' : isAuthScreen}" style="">
        <div class="container">
          <div :key="kljuc" class="breadcrumbs">
            <breadcrumbs></breadcrumbs>
          </div>
          <section class="content">
            <router-view></router-view>
          </section>
        </div>
        <!-- /.container -->
      </div>
      <!-- /.content-wrapper -->
      <!--<footer class="main-footer">
        <div class="container">
          <div class="row" v-if="isCollapsed()">
            <div class="col-xs-5">
              <img class="img img-responsive margin" :src="mizsUrl">
            </div>
            <div class="col-xs-5">
              <img class="img img-responsive margin" :src="euUrl">
            </div>
            <div class="col-xs-2">
              <div class="pull-right xs-hidden">
                <b><small>{{ $t('header.version') }}</small></b> 4.0
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-xs-4">
              <img class="img img-responsive margin" style="margin-top: 2em;" :src="mizsUrl">
            </div>
            <div class="col-xs-4">
              <img class="img img-responsive margin" :src="euUrl">
            </div>
            <div class="col-xs-4">
              <div class="pull-right hidden-xs">
                <br>
                <b>Podpora: </b>podpora.equiz@gmail.com
                <br>
                <b>{{ $t('header.version') }}:</b> 5.0
              </div>
            </div>
          </div>
        </div>
        <! /.container -
      </footer>-->
    </div>
    <!-- ./wrapper -->
  </div>
</template>
<script>
  import Auth from './../../services/auth'
  import router from './../../router/router'
  // import { Observable } from 'rxjs/Observable'
  // import Rx from 'rxjs/Rx'
  import { mapGetters, mapState } from 'vuex'

  export default {
    data () {
      return {
        locale: 'en',
        kljuc: 'something'
      }
    },
    computed: {
      ...mapState({
        groupList: state => state.groupList,
        allGroups: state => state.allGroups,
        currUser: state => state.userData,
        defaultGColor: state => state.defaultGColor,
        selectedGroup: state => state.selectedGroup,
        selectedGroupId: state => state.selectedGroupId,
        mizsUrl: state => state.mizsUrl,
        euUrl: state => state.osnovniUrl,
        selectedYear: state => state.selectedYear
      }),
      ...mapGetters({
        pictureBaseURL: 'pictureBaseURL',
        userId: 'getUserId',
        jeAdmin: 'hasAdminRole',
        profilePicture: 'getProfilePictureUrlForDisplay',
        userLoggedIn: 'getConcatUserNameSurname',
        isLoggedOut: 'getSessionRefreshToken',
        reports: 'getReports'
      }),
      isAuthenticated () {
        return Auth.isAuthenticated()
      },
      isSimpleHeader () {
        return this.$route.meta.simpleHeader || !this.userLoggedIn
      },
      // group that shows up in the header
      headerGroup () {
        if (this.selectedGroupId) {
          return this.selectedGroup
        }
      },
      pendingReports () {
        return this.reports.filter((rep) => rep.status === 'pending')
      },
      isAuthScreen () {
        return this.$route.path === '/'
      }
    },
    created () {
      this.changeLocale(Auth.getFromLocalStorage('language'))
      if (this.isAuthenticated) {
        this.$store.dispatch('getUserData')
        this.$store.dispatch('getGroupsNew')
        this.$store.dispatch('getAllGroups')
      }
    },
    mounted () {
      if (this.jeAdmin) {
        this.$store.dispatch('getReports')
      }
    },
    methods: {
      updateReports () {
        this.$store.dispatch('getReports')
      },
      isCollapsed () {
        // 767/768px meja
        return window.innerWidth < 768
      },
      navigateToGroup (group) {
        router.push({name: 'exercises', params: {gid: group.id, yid: this.selectedYear.id, sid: 'root'}})
      },
      navigateToGroupAdmin (group) {
        this.$store.commit('updateSelectedGroup', group)
        this.$store.commit('updateSelectedYear')
        router.push({name: 'exercises', params: {gid: group.id, yid: this.selectedYear.id, sid: 'root'}})
      },
      s () {
        if (this.jeAdmin) {
          router.push({name: 'adminGroups'})
        } else {
          router.push({name: 'groupList'})
        }
      },
      homeButton () {
        if (!this.selectedGroupId && !this.jeAdmin) {
          router.push({name: 'groupList'})
        } else if (!this.selectedGroupId && this.jeAdmin) {
          router.push({name: 'adminGroups'})
        } else if (this.selectedGroupId && !this.jeAdmin) {
          if (this.$route.name === 'exercises' && this.$route.params.sid === 'root') {
            router.push({name: 'groupList'})
          } else {
            router.push({name: 'exercises', params: {gid: this.selectedGroupId.toString(), yid: this.selectedYear.id, sid: 'root'}})
          }
        } else {
          if (this.$route.name === 'exercisesAdmin' && this.$route.params.sid === 'root') {
            router.push({name: 'adminGroups'})
          } else {
            router.push({name: 'exercisesAdmin', params: {gid: this.selectedGroupId.toString(), yid: this.selectedYear.id, sid: 'root'}})
          }
        }
      },
      goToExercises () {
        router.push({name: 'exercises', params: {gid: this.selectedGroupId.toString(), yid: this.selectedYear.id, sid: 'root'}})
      },
      goToProgress () {
        router.push({name: 'UserRating', params: {gid: this.selectedGroupId.toString(), yid: this.selectedYear.id}})
      },
      leaveGroup () {
        if (!this.jeAdmin) {
          router.push({name: 'groupList'})
        } else {
          router.push({name: 'adminGroups'})
        }
      },
      goToClasses () {
        router.push({name: 'classes', params: {gid: this.selectedGroupId.toString(), yid: this.selectedYear.id.toString()}})
      },
      goToPanel () {
        router.push({name: 'admin', params: {gid: this.selectedGroupId.toString(), yid: this.selectedYear.id.toString()}})
      },
      goToLibrary () {
        router.push({name: 'library'})
      },
      goToUsers () {
        router.push({name: 'users'})
      },
      goToTablets () {
        router.push({name: 'tablets'})
      },
      logout () {
        this.$store.dispatch('logout')
      },
      goToProfile (userId) {
        router.push({name: 'profile'})
      },
      changeLocale (lokale) {
        if (lokale) {
          this.$i18n.locale = lokale
          Auth.saveToLocalStorage('language', lokale)
          if (this.isAuthenticated) {
            this.$store.dispatch('updateLanguage', lokale)
          }
        } else {
          this.$i18n.locale = 'sl'
          Auth.saveToLocalStorage('language', this.$i18n.locale)
        }
      },
      changeYear (year) {
        this.$store.commit('updateSelectedYear', year) // update group selection
        router.push({name: '', params: {gid: this.selectedGroupId.toString(), yid: this.selectedYear.id.toString(), sid: 'root'}})
        if (this.$route.name === 'classes') {
          this.$router.go()
        }
      }
    },
    watch: {
      locale (val) {
        this.$i18n.locale = val
      }
    }
  }

</script>

<style>
.breadcrumbs {
  padding-top: 1em;
}

@media print {
  .breadcrumbs {
    display: none;
  }
}

img {
  height: 30em;
  width: 20em;
  vertical-align: middle;
}
.margin-one {
  width: 16em;
}
.margin-two {
  margin-top: 0.5em;
}
.navbar-toggle:hover {
  background: none !important;
}
.navbar-toggle:focus {
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// header.vue?676d871b